<template>
  <div>
    <v-row v-if="isError">
      <v-col cols="12">
        <v-alert type="error">
          {{ hosting_error }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="!isError && inactiveService">
      <v-col cols="12" sm="6">
        <service-info />
      </v-col>
      <v-col cols="12" sm="6">
        <hosting-pending :status="hosting.status" />
      </v-col>
    </v-row>
    <v-row v-if="!isError && !inactiveService">
      <v-col cols="12" class="pt-0">
        <gg-loading :loading="loading" type="image" height="400">
          <router-view :loading="loading"/>
        </gg-loading>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ServiceInfo from 'Components/Services/Hosting/Common/ServiceInfo'
import HostingPending from 'Components/Services/Hosting/Common/HostingPending'

export default {
  name: 'ResellerService',
  components: {
    ServiceInfo, HostingPending
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['hosting', 'hostingPopulated', 'hosting_error']),
    isError () {
      return this.hosting_error !== null
    },
    hostingid () {
      return this.$route.params.hostingid
    },
    inactiveService () {
      return this.hosting.status === 'Pending' || this.hosting.status === 'Suspended'
    }
  },
}
</script>
